import { observer } from "mobx-react-lite";
import styled from "styled-components";
import { Card, Elevation, NonIdealState } from "@blueprintjs/core";
import { faExclamationTriangle } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { POSSIBLE_ERROR_STATES } from "@pages/editor/stores";

interface Props {
  errorState: POSSIBLE_ERROR_STATES;
}

const Container = styled.div`
  display: flex;
  background: var(--global-off-white);
  justify-content: center;
  align-items: center;
  padding-bottom: 20%;
`;

const ErrorContainer = styled(Card)`
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 20px;
  padding: 40px;
`;

const ErrorStates = ({ errorState }: Props) => {
  var errorName, message;
  if (errorState === "notFound") {
    errorName = "RULE NOT FOUND";
    message = (
      <p>
        The currently selected rule cannot be found. <br /> It might have been
        deleted. <br />
        Try searching for a different rule.
      </p>
    );
  } else if (errorState === "unknownError") {
    errorName = "SOMETHING WENT WRONG";
    message = (
      <p>
        The editor reached an unrecoverable error. <br /> Try refreshing the
        page.
      </p>
    );
  }
  return (
    <Container>
      <ErrorContainer elevation={Elevation.ONE}>
        <NonIdealState
          icon={<FontAwesomeIcon icon={faExclamationTriangle} />}
          title={errorName}
          description={message}
        />
      </ErrorContainer>
    </Container>
  );
};

export const EditorErrorStates = observer(ErrorStates);
